<template>
  <b-tooltip :position="getTooltipPosition()" multilined type="is-dark" :class="getTooltipClass()">
    <div ref="launcherWrapper"></div>
    <template #content>
      <span>{{ $t("Explanation.Tooltip") }}</span>
    </template>
  </b-tooltip>
</template>

<script lang="ts">
import { BModalComponent } from "buefy/types/components";
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { ExplanationPopupData, ExplanationSendEmailRequest, ExplanationSaveImageFileRequest, ExplanationSendAlgoliaResponseItem } from "@/models/ExplanationPopupData";
import { Result } from "@/models/Result";
import HelperService from "@/services/HelperService";
import ApiService from "@/services/api/ApiService";

@Component({
  components: {},
})
export default class ExplanationPopup extends Vue {

  data: ExplanationSendEmailRequest | null = null;
  modal: BModalComponent | null = null; 

  mounted() {
    let intercomLauncherElements: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-launcher");
    if (intercomLauncherElements.length === 0) {
      ApiService.getExplanationPopup().then((explanation: ExplanationPopupData) => {
        if (explanation.found) {
          this.initPopup(explanation);
        }
      });
    }
  }

  private getTooltipPosition(): string {
    let result = "";
    switch (i18n.locale) {
      case "en-US":
        result = "is-left";
        break;
      case "he-IL":
        result = "is-right";
        break;      
    }
    return result;
  }

  private getTooltipClass(): string {
    let result = "";
    switch (i18n.locale) {
      case "en-US":
        result = "ltr-question-tooltip";
        break;
      case "he-IL":
        result = "rtl-question-tooltip";
        break;      
    }
    return result;
  }

  private addFieldError(el: HTMLElement | null): void {
    const errorLbl: HTMLLabelElement = document.createElement("label");
    errorLbl.className = "error";
    let errorMsg = "";
    switch (i18n.locale) {
      case "en-US":
        errorMsg = "This field is required";
        break;
      case "he-IL":
        errorMsg = "שדה חובה";
        break;
    }
    errorLbl.innerText = errorMsg;
    el?.insertAdjacentElement("afterend", errorLbl);
  }

  private initPopup(explanation: ExplanationPopupData) {
    const modalContent: HTMLDivElement = document.createElement('div');
    modalContent.innerHTML = explanation.html;
    const intercomLauncherWrapperElements: HTMLCollectionOf<Element> = modalContent.getElementsByClassName("intercom-launcher-wrapper");
    if (intercomLauncherWrapperElements.length > 0) {
      const linkStyle: HTMLCollectionOf<HTMLLinkElement> = modalContent.getElementsByTagName("link");
      if (linkStyle.length > 0) {
        (this.$refs.launcherWrapper as HTMLDivElement).appendChild(linkStyle[0]);
      }
      const imageModal: HTMLCollectionOf<HTMLDivElement> = modalContent.getElementsByClassName("intercom-image-modal") as HTMLCollectionOf<HTMLDivElement>;
      if (imageModal.length > 0) {
        imageModal[0].style.display = "none";
        (this.$refs.launcherWrapper as HTMLDivElement).appendChild(imageModal[0]);

        setTimeout(()=>{
          if (imageModal && imageModal[0]) {
            imageModal[0].style.display = "block";
          }
        }, 300);
      }
      const intercomLauncherWrapperElement: HTMLDivElement = intercomLauncherWrapperElements[0] as HTMLDivElement;
      intercomLauncherWrapperElement.style.display = "none";
      setTimeout(()=>{intercomLauncherWrapperElement.style.display = "block";}, 300);
      (this.$refs.launcherWrapper as HTMLDivElement).appendChild(intercomLauncherWrapperElement);
      let intercomLauncherElements: HTMLCollectionOf<Element> = intercomLauncherWrapperElement.getElementsByClassName("intercom-launcher");
      if (intercomLauncherElements.length > 0) {
        const launcherEl: HTMLDivElement = intercomLauncherElements[0] as HTMLDivElement;
        let formSelectImageButton: HTMLCollectionOf<Element> = document.getElementsByClassName("imagefile");
        if (formSelectImageButton.length > 0) {
          const formSelectImageButtonEl: HTMLInputElement = formSelectImageButton[0] as HTMLInputElement;
          let buttonAddFile: HTMLButtonElement | null = document.querySelector(".intercom-button-file-upload") as HTMLButtonElement;
          if(buttonAddFile){
            buttonAddFile.addEventListener('click',(e: Event)=>{ 
              formSelectImageButtonEl.click()
            });
          }
          formSelectImageButtonEl.addEventListener("change", (e: Event) => {
            let file = formSelectImageButtonEl.files;
            let errorSize: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("upload-image-result-error") as HTMLCollectionOf<HTMLDivElement>;
            if (file) {
              if (file[0].size > 200000) {
                errorSize[0].style.display = "block";
                return false;
              }
              errorSize[0].style.display = "none";
              let imageName = file[0].name;
              let imageResult: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("upload-image-result") as HTMLCollectionOf<HTMLDivElement>;
              imageResult[0].innerHTML = imageName;
              var reader = new FileReader();
              reader.onload = function (e) {
                if (e.target) {
                  let loadimage = e.target.result?.toString();
                  if (!loadimage) {
                    loadimage = "";
                  }
                  const data: ExplanationSaveImageFileRequest = {
                    image: loadimage,
                    imagename: imageName
                  };
                  ApiService.saveExplanationModuleImage(data).then((result: Result) => {
                    if (result.Success) {
                      let url = result.Data.toString();
                      let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("loaded-image-result") as HTMLCollectionOf<HTMLDivElement>;
                      if (form.length > 0) {
                        let elementCount = form[0].childElementCount;
                        if (elementCount < 5) {
                          const divEl: HTMLDivElement = document.createElement("div");
                          divEl.className = "intercom-image-row";
                          const link: HTMLAnchorElement = document.createElement("a");
                          link.href = url;
                          link.text = imageName;
                          link.target = '_blank';
                          divEl.appendChild(link);
                          const deleteImageEl: HTMLSpanElement = document.createElement("span");
                          deleteImageEl.className = "intercom-image-delete";
                          deleteImageEl.innerHTML = "&times";
                          divEl.append(deleteImageEl);
                          const breake: HTMLBRElement = document.createElement("br");
                          divEl.append(breake);
                          let result: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("loaded-image-result") as HTMLCollectionOf<HTMLDivElement>;
                          result[0].append(divEl);
                          let formDeleteImageButton: HTMLCollectionOf<HTMLSpanElement> = document.getElementsByClassName("intercom-image-delete") as HTMLCollectionOf<HTMLSpanElement>;
                          if (formDeleteImageButton.length > 0) {
                            for (let i = 0; i < formDeleteImageButton.length; i++) {
                              const formDeleteImageButtonEl: HTMLSpanElement = formDeleteImageButton[i] as HTMLSpanElement;
                              formDeleteImageButtonEl.addEventListener("click", (e) => {
                                if (e != null && e.target != null) {
                                  let deleteButton: HTMLSpanElement = e.target as HTMLSpanElement;
                                  if (deleteButton.parentNode != null) {
                                    let parentElementDelete: HTMLDivElement = deleteButton.parentNode as HTMLDivElement;
                                    parentElementDelete.remove();
                                    imageResult[0].innerHTML ='';
                                  }
                                }
                              });
                            }
                          }

                          let modal: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-image-modal") as HTMLCollectionOf<HTMLDivElement>;
                          modal[0].style.display = "none";
                        } else {
                          let errorCount: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("upload-image-result-count-error") as HTMLCollectionOf<HTMLDivElement>;
                          errorCount[0].style.display = "block";
                        }
                      }
                    } else {
                      HelperService.showError(result.Message);
                    }
                  });
                }
              }
              reader.readAsDataURL(file[0]);
            }
          });
        }
        launcherEl.addEventListener("click", () => {
          launcherEl.classList.toggle("is-active");
          let container: HTMLCollectionOf<HTMLDivElement> = modalContent.getElementsByClassName("intercom-messenger-container") as HTMLCollectionOf<HTMLDivElement>;       
          if (container.length > 0) {
            const containerEl: HTMLDivElement = container[0];
            if (launcherEl.classList.contains("is-active")) {
              this.modal = HelperService.showModal(containerEl.innerHTML, 376, "intercom-modal", "slide");
              setTimeout(() => {
                let formSearchButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button-search");
                if (formSearchButton.length > 0) {
                  const formSearchButtonEl: HTMLButtonElement = formSearchButton[0] as HTMLButtonElement;
                  const subjectEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='subject']");
                  let videoEl: HTMLDivElement | null = document.querySelector(".intercom-messenger-video") as HTMLDivElement;
                  if(subjectEl){
                    subjectEl.addEventListener('keyup', (e:KeyboardEvent) =>{
                      if(e.key === 'Enter'){
                        e.preventDefault();                       
                        formSearchButtonEl.click();
                      }
                    })
                  }
                  formSearchButtonEl.addEventListener("click", (e: Event) => {
                    e.preventDefault();
                    let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-form") as HTMLCollectionOf<HTMLDivElement>;
                    let formFaq: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-faq") as HTMLCollectionOf<HTMLDivElement>;
                    if (form.length > 0 && formFaq.length > 0) {
                      const formEl: HTMLDivElement = form[form.length - 1] as HTMLDivElement;
                      const formFaqEl: HTMLDivElement = formFaq[0] as HTMLDivElement;                   
                      const subject: string = subjectEl !== null ? subjectEl.value : "";
                      let loader = this.$loading.show({
                        container: formEl
                      });
                      ApiService.sendExplanationModuleAlgoliaPost(subject).then((result: Result) => {
                          if (result.Success) {                            
                            if (videoEl){
                              videoEl.style.display = "none";
                            }
                          var data = result.Data as ExplanationSendAlgoliaResponseItem[];
                          if (data.length > 0) {
                            let formInsert: HTMLDivElement = document.querySelector(".intercom-messenger-faq .intercom-form-group") as HTMLDivElement;
                            data.forEach((element: ExplanationSendAlgoliaResponseItem) => {
                              const parag: HTMLParagraphElement = document.createElement("p");
                              parag.textContent = element.content;
                              formInsert.after(parag);
                              const link: HTMLAnchorElement = document.createElement("a");
                              link.href = element.permalink;
                              link.text = element.post_title;
                              link.target = "_blank";
                              formInsert.after(link);
                            });
                            formEl.style.display = "none";
                            formFaqEl.style.display = "block";
                            let subjectErrorEl = document.getElementById("error-subject-message");
                            if (subjectErrorEl) {
                              subjectErrorEl.style.display = "none";
                            }
                          } else {
                            this.showsendform();
                            let subjectErrorEl = document.getElementById("error-subject-message");
                            if (subjectErrorEl) {
                              subjectErrorEl.style.display = "none";
                            }
                          }
                        } else {
                          let subjectErrorEl = document.getElementById("error-subject-message");
                          if (!subjectErrorEl) {
                            subjectErrorEl = document.createElement("div");
                            subjectErrorEl.id = "error-subject-message";
                            subjectErrorEl.innerHTML = "<div class='tooltip-wrapper'>" + result.Message + "</div>";
                            formEl.appendChild(subjectErrorEl);
                          }
                        }
                      }).finally(() => {
                        loader.hide();
                      });

                      const errorLabels: NodeListOf<HTMLLabelElement> = formEl.querySelectorAll("label.error");
                      errorLabels.forEach((errorLabel: HTMLLabelElement) => {
                        errorLabel.remove();
                      })
                      let formButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button");
                      if (formButton.length > 0) {
                        const formButtonEl: HTMLButtonElement = formButton[0] as HTMLButtonElement;
                        formButtonEl.addEventListener("click", (e: Event) => {
                          e.preventDefault();
                          var hasErrors = this.validForm();
                          if (!hasErrors && this.data != null) {
                            this.sendMessage(this.data);
                          }
                        });
                      }
                      let formButtonYes: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button-yes");
                      if (formButtonYes.length > 0) {
                        const formButtonEl: HTMLButtonElement = formButtonYes[0] as HTMLButtonElement;
                        formButtonEl.addEventListener("click", (e: Event) => {
                          e.preventDefault();
                          let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-form") as HTMLCollectionOf<HTMLDivElement>;
                          let formFaq: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-faq") as HTMLCollectionOf<HTMLDivElement>;
                          let formMessage: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-message") as HTMLCollectionOf<HTMLDivElement>;
                          if (form.length > 0 && formFaq.length > 0 && formMessage.length > 0) {
                            const formEl: HTMLDivElement = form[form.length - 1] as HTMLDivElement;
                            const formFaqEl: HTMLDivElement = formFaq[0] as HTMLDivElement;
                            const formMessageEl: HTMLDivElement = formMessage[0] as HTMLDivElement;
                            formEl.style.display = "none";
                            formFaqEl.style.display = "none";
                            formMessageEl.style.display = "block";
                          }
                        });
                      }
                      let formButtonNo: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button-no");
                      if (formButtonNo.length > 0) {
                        const formButtonEl: HTMLButtonElement = formButtonNo[0] as HTMLButtonElement;
                        formButtonEl.addEventListener("click", (e: Event) => {
                          e.preventDefault();
                          this.showsendform();
                        });
                      }
                      let formSubject: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='subject']");
                      if (formSubject) {
                        formSubject.addEventListener("keydown", (e: KeyboardEvent) => {
                          let value = formSubject?.value;
                          if (value && e.key === "Space" && value.length < 1) {
                            return false;
                          }
                        });
                      }
                      let formButtonBack: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button-back");
                      if (formButtonBack.length > 0) {
                        const formButtonBackEl: HTMLButtonElement = formButtonBack[0] as HTMLButtonElement;
                        formButtonBackEl.addEventListener("click", (e: Event) => {
                          e.preventDefault();
                          let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-form") as HTMLCollectionOf<HTMLDivElement>;
                          let formFaq: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-faq") as HTMLCollectionOf<HTMLDivElement>;
                          let formSearchButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button-search");
                          let formButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button");
                          if (form.length > 0 && formFaq.length > 0 && formSearchButton.length > 0 && formButton.length > 0) {
                            const formEl: HTMLDivElement = form[form.length - 1] as HTMLDivElement;
                            const formFaqEl: HTMLDivElement = formFaq[0] as HTMLDivElement;
                            const formSearchButtonEl: HTMLButtonElement = formSearchButton[0] as HTMLButtonElement;
                            const formButtonEl: HTMLButtonElement = formButton[0] as HTMLButtonElement;
                            formSearchButtonEl.style.display = "block";
                            formButtonEl.style.display = "none"
                            formEl.style.display = "block";
                            formFaqEl.style.display = "none";
                            if (videoEl){
                              videoEl.style.display = "block";
                            }
                          }
                        });
                      }
                      const formUploadImageButton: HTMLCollectionOf<Element> = document.getElementsByClassName("upload-image-file");
                      if (formUploadImageButton.length > 0) {
                        const formUploadImageButtonEl: HTMLInputElement = formUploadImageButton[0] as HTMLInputElement;
                        formUploadImageButtonEl.addEventListener("click", () => {
                          const imageModal: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-image-modal") as HTMLCollectionOf<HTMLDivElement>;
                          if (imageModal.length > 0) {
                            const modalEl: HTMLDivElement = imageModal[0] as HTMLDivElement;
                            modalEl.style.display = "block";
                          }
                        });
                      }
                      const formCloseImageButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-image-close");
                      if (formCloseImageButton.length > 0) {
                        const formCloseImageButtonEl: HTMLInputElement = formCloseImageButton[0] as HTMLInputElement;
                        formCloseImageButtonEl.addEventListener("click", () => {
                          const imageModal: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-image-modal") as HTMLCollectionOf<HTMLDivElement>;
                          if (imageModal.length > 0) {
                            const modalEl: HTMLDivElement = imageModal[0] as HTMLDivElement;
                            modalEl.style.display = "none";
                          }

                        });
                      }
                    }
                  });
                }
              })
            }
            else if (this.modal !== null) {
              this.modal.close();
            }
          }
        });
        if (launcherEl.dataset.openByDefault === "true") {
          launcherEl.click();
        }
      }
    }
  }

  showsendform(): void{
    let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-form") as HTMLCollectionOf<HTMLDivElement>; 
    let formFaq: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-faq") as HTMLCollectionOf<HTMLDivElement>;
    let formSearchButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button-search");
    let formButton: HTMLCollectionOf<Element> = document.getElementsByClassName("intercom-button");
    if (form.length > 0 && formFaq.length > 0 && formSearchButton.length > 0 && formButton.length > 0) {
      const formEl: HTMLDivElement = form[form.length - 1] as HTMLDivElement;
      const formFaqEl: HTMLDivElement = formFaq[0] as HTMLDivElement;
      const formSearchButtonEl: HTMLButtonElement = formSearchButton[0] as HTMLButtonElement;
      const formButtonEl: HTMLButtonElement = formButton[0] as HTMLButtonElement;
      const nameEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='name']");
      if(nameEl != null){
        nameEl.style.display = "block";
      }
      const messageEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='message']");
      if(messageEl != null){
        messageEl.style.display = "block";
      }
      const emailEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='email']");
      if(emailEl != null){
        emailEl.style.display = "block";
      }
      const phoneEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='phone']");
      if(phoneEl != null){
        phoneEl.style.display = "block";
      }

      const fileEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form .upload-image-file");
      if(fileEl != null){
        fileEl.style.display = "block";
      }
      
      formSearchButtonEl.style.display = "none";
      formButtonEl.style.display = "block"
      formEl.style.display = "block";  
      formFaqEl.style.display = "none";
    }
  }

  validForm(): boolean {

    let hasErrors = false;
    
    let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-form") as HTMLCollectionOf<HTMLDivElement>;
    if (form.length > 0) {
      const formEl: HTMLDivElement = form[form.length - 1] as HTMLDivElement;
      let username: string | null = null;
      var locale: string | null = null;
      if (typeof((window as any).fixdigital_explanation) != "undefined") { 
        if ((window as any).fixdigital_explanation && (window as any).fixdigital_explanation.username) {
          username = (window as any).fixdigital_explanation.username;
        }
        if ((window as any).fixdigital_explanation && (window as any).fixdigital_explanation.locale) {
          locale = (window as any).fixdigital_explanation.locale;
        }
      }

      const errorLabels: NodeListOf<HTMLLabelElement> = formEl.querySelectorAll("label.error");
      errorLabels.forEach((errorLabel: HTMLLabelElement) => {
        errorLabel.remove();
      })

      const messageEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='subject']");
      const message: string = messageEl !== null ? messageEl.value : "";
      if (message === "") {
        hasErrors = true;
        this.addFieldError(messageEl);
      }
      const image: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("loaded-image-result") as HTMLCollectionOf<HTMLDivElement>;
      let images = image[0].children;
      var imagesUrl = "";
      for (var i = 0; i < images.length; i++) {
        if (images[i].children.length > 0)
        {
          var elementLink: HTMLLinkElement = images[i].children[0] as HTMLLinkElement;
          if (elementLink.localName === 'a') {
            imagesUrl += "<a href='" + elementLink.href + "'>" + elementLink.textContent + "</a>";
            if (i != images.length - 1) {
              imagesUrl += ', ';
            }
          }
        }
      }
      const messageWithImage = message + " " + imagesUrl;
      
      const emailEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='email']");
      const email: string = emailEl !== null ? emailEl.value : "";
      if (email === "") {
        hasErrors = true;
        this.addFieldError(emailEl);
      }
      const nameEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='name']");
      const name: string = nameEl !== null ? nameEl.value : "";
      if (name === "") {
        hasErrors = true;
        this.addFieldError(nameEl);
      }
      
      const phoneEl: HTMLTextAreaElement | null = document.querySelector(".intercom-messenger-form [name='phone']");
      const phone: string = phoneEl !== null ? phoneEl.value : "";
      if (!hasErrors) {
        this.data = {
          url: location.href,  
          message: messageWithImage,
          username: username !== null ? username : "",
          email,
          name,
          phone,
          locale: locale !== null ? locale : "",
          subject: message
        }
      }
    }
    return hasErrors;
  }

  sendMessage(request: ExplanationSendEmailRequest, isNobutton: boolean = false){
    let form: HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName("intercom-messenger-form") as HTMLCollectionOf<HTMLDivElement>;
    if(isNobutton){
       form = document.getElementsByClassName("intercom-messenger-faq") as HTMLCollectionOf<HTMLDivElement>;
    }  
    if (form.length > 0) {
      const formEl: HTMLDivElement = form[form.length - 1] as HTMLDivElement;
      let loader = this.$loading.show({
        container: formEl
      });
      ApiService.sendExplanationModuleEmail(request).then((result: Result) => {
        if (result.Success) {         
          formEl.innerHTML = result.Message;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
  }
  
}
</script>

<style lang="scss" scoped>

  .ltr-question-tooltip {
    @media (min-width: 1881px) {
      left: 96%;
    }
    position: fixed;
    left: 95%;
    top: 95%;
    z-index: 2;
    @media (max-width: 1441px) {
      left: 94%;
    }
    @media (max-width: 1233px) {
      left: 93%;
    }

  }

  .rtl-question-tooltip {
    @media (min-width: 1881px) {
      left: 4%;
    }
    position: fixed;
    left: 5%;
    top: 95%;
    z-index: 2;
    @media (max-width: 1441px) {
      left: 6%;
    }
    @media (max-width: 1233px) {
      left: 7%;
    }

  }

</style>
